import React, { useContext, useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";
import "../../../assets/css/user/notificaiton/Notification.css";

import {
  Check,
  CheckCheck,
  Bell,
  Store,
  CircleDollarSign,
  Users,
} from "lucide-react";

export default function Notifications() {
  const { baseUrl, loggedInCustomer } = useContext(AppContext);

  const [notifications, setNotifications] = useState([]);

  const [loading, setLoading] = useState(false);

  const [markAllLoading, setMarkAllLoading] = useState(false);

  // ================= FETCH NOTIFICATIONS =================
  const viewAllNotifications = () => {
    console.log("loggedInCustomer:", loggedInCustomer);

    if (!loggedInCustomer?.id) return;

    setLoading(true);

    const formData = new FormData();

    formData.append("tpcustomer_id", loggedInCustomer.id);

    axios
      .post(`${baseUrl}/customer/notification/viewAllNotification`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        console.log("Notification Response:", response.data);

        setNotifications(response.data.notifications || []);

        setLoading(false);
      })
      .catch((error) => {
        console.log("Notification Error:", error.response?.data);

        setLoading(false);
      });
  };
  // ================= MARK SINGLE =================
  const markSingleAsRead = (id) => {
    const formData = new FormData();

    formData.append("id", id);

    formData.append("status", "read");

    axios
      .post(`${baseUrl}/customer/notification/markSingleAsRead`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        if (response.data.success) {
          setNotifications((prev) =>
            prev.map((item) =>
              item.id === id
                ? {
                    ...item,
                    status: "read",
                  }
                : item,
            ),
          );

          Swal.fire({
            icon: "success",
            title: "Notification",
            text: response.data.message,
          });
        }
      })
      .catch((error) => {
        console.log(error.response?.data);
      });
  };

  // ================= MARK ALL =================
  const markAllAsRead = () => {
    if (!loggedInCustomer?.id) return;

    setMarkAllLoading(true);

    const formData = new FormData();

    formData.append("tpcustomer_id", loggedInCustomer.id);

    axios
      .post(`${baseUrl}/customer/notification/markAllAsRead`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      })
      .then((response) => {
        setNotifications((prev) =>
          prev.map((item) => ({
            ...item,
            status: "read",
          })),
        );

        setMarkAllLoading(false);

        Swal.fire({
          icon: "success",
          title: "Success",
          text: "All notifications marked as read",
        });
      })
      .catch((error) => {
        console.log(error.response?.data);

        setMarkAllLoading(false);
      });
  };

  // ================= USE EFFECT =================
 useEffect(() => {
  console.log("loggedInCustomer Notification:", loggedInCustomer);

  if (!loggedInCustomer?.id) return;

  // Page open hote hi notifications fetch
  viewAllNotifications();

  // Har 1 minute baad notifications dobara fetch
  const interval = setInterval(() => {
    viewAllNotifications();
  }, 60000);

  // Component unmount hone par interval stop
  return () => clearInterval(interval);

}, [loggedInCustomer]);

  const unreadCount = notifications.filter((n) => n.status === "unread").length;

  return (
    <div className="page">
      {/* HEADER */}
      <header className="page-header">
        <div className="header-left">
          <h1 className="page-title">Notifications</h1>

          <p className="page-subtitle">Stay updated with your orders & deals</p>
        </div>

        <button
          className="mark-all-btn"
          onClick={markAllAsRead}
          disabled={unreadCount === 0 || markAllLoading}
        >
          {markAllLoading ? (
            <span className="spinner-border spinner-border-sm"></span>
          ) : (
            <>
              <Check size={16} />
              Mark All as Read
            </>
          )}
        </button>
      </header>

      {/* CARD */}
      <section className="notifications-card">
        <div className="section-heading">
          <span className="bell-icon">
            <Bell size={20} />
          </span>

          <h2>Recent Notifications</h2>

          {unreadCount > 0 && (
            <span className="unread-badge">{unreadCount}</span>
          )}
        </div>

        {/* LOADING */}
        {loading ? (
          <div className="text-center py-4">
            <span className="spinner-border"></span>
          </div>
        ) : (
          <ul className="notification-list">
            {notifications.length === 0 ? (
              <div className="text-center py-4">No Notifications Found</div>
            ) : (
              notifications.map((item) => (
                <li
                  key={item.id}
                  className={`notification-item ${
                    item.status === "read" ? "read" : "unread"
                  }`}
                >
                  {/* ICON */}
                  <div className="notif-icon orange">
                    {item.icon === "shop" ? (
                      <Store size={18} />
                    ) : item.icon === "payment" ? (
                      <CircleDollarSign size={18} />
                    ) : item.icon === "chat" ? (
                      <Users size={18} />
                    ) : (
                      <Bell size={18} />
                    )}
                  </div>

                  {/* BODY */}
                  <div className="notif-body">
                    <div className="notif-title-row">
                      <span className="notif-title">{item.title}</span>

                      {item.status === "unread" && (
                        <span className="unread-dot" />
                      )}
                    </div>

                    <p className="notif-desc">{item.description}</p>

                    <span className="notif-time">
                      {new Date(item.created_at).toLocaleDateString("en-GB")}
                    </span>
                  </div>

                  {/* CHECK */}
                  <button
                    className={`notif-check ${
                      item.status === "read" ? "read-check" : ""
                    }`}
                    onClick={() => markSingleAsRead(item.id)}
                    disabled={item.status === "read"}
                  >
                    {item.status === "read" ? (
                      <CheckCheck size={18} />
                    ) : (
                      <Check size={18} />
                    )}
                  </button>
                </li>
              ))
            )}
          </ul>
        )}
      </section>
    </div>
  );
}
